import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BaseComponent } from '../../../../components/base/base.component';
import {
  PayrollJournalEntry,
  PayrollJournalSearchConfig
} from '../../../../models/payroll-journal';
import { isFormatted, parseDatePickerValue } from '../../../../utils/datepicker-value-parser';
import { PagedPayload } from '../../../../models/paged-payload';
import { AuditService } from '../../../../services/audit.service';
import { Pagination } from '../../../../models/pagination';

@Component({
  selector: 'payroll-audit-log',
  templateUrl: './payroll-audit-log.component.html',
  styleUrls: ['./payroll-audit-log.component.css'],
  standalone: false
})
export class PayrollAuditLogComponent extends BaseComponent implements OnInit {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() public clientCode: string;
  public searchConfig: PayrollJournalSearchConfig;
  public showMore: any[] = []; // toggle showing more when Info column is truncated
  public payload: PagedPayload<PayrollJournalEntry>;

  private searchSubject = new Subject<void>();

  constructor(
    private auditService: AuditService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.searchConfig = new PayrollJournalSearchConfig();

    this.searchConfig.ClientCode = this.clientCode;
    this.searchConfig.EarliestDate = this.startDate;
    this.searchConfig.LatestDate = this.endDate;

    this._searchPayrollJournal();

    this.searchSubject.pipe(debounceTime(500)).subscribe(() => this._searchPayrollJournal());
  }

  public filterBy(event) {
    this.payload.Pagination.Page = 1; // reset pagination after filters change
    this.searchSubject.next();
  }

  public loadPage({ Page }: Pagination) {
    this.payload.Pagination.Page = Page;
    this._searchPayrollJournal();
  }

  public search() {
    // update the search config with the
    // sortkey and sortdirection set in BaseComponent
    this.searchConfig.SortKey = this.sortKey;
    this.searchConfig.SortDirection = this.sortDirection;
    this._searchPayrollJournal();
  }

  private _searchPayrollJournal() {
    // if custom date's were picked, the datepicker format needs parsing
    if (isFormatted(this.searchConfig.EarliestDate)) {
      this.searchConfig.EarliestDate = parseDatePickerValue(this.searchConfig.EarliestDate);
    }

    if (isFormatted(this.searchConfig.LatestDate)) {
      this.searchConfig.LatestDate = parseDatePickerValue(this.searchConfig.LatestDate);
    }

    // if the requested page has changed, update the search config
    if (this.payload && this.payload.Pagination) {
      this.searchConfig.PageNumber = this.payload.Pagination.Page;
    }

    this.auditService.searchPayrollJournal(this.searchConfig).subscribe(resp => {
      this.payload = resp;
    });
  }
}
